import hubspotLogo from 'assets/images/composio/hubspot.png';
import outlookLogo from 'assets/images/composio/outlook.png';

/** Hardcoded logos for the only two supported connector toolkits. */
const LOCAL_TOOLKIT_LOGOS: Record<string, string> = {
  HUBSPOT: hubspotLogo,
  OUTLOOK: outlookLogo,
};

function normalizeToolkitSlug(value: string): string {
  return value.trim().toUpperCase().replace(/[\s-]+/g, '_');
}

/**
 * Resolve a hardcoded brand logo from a Composio toolkit slug (e.g. HUBSPOT, OUTLOOK).
 * Display names are ignored — pass the toolkit slug from ComposioConfig.
 */
export function resolveComposioToolLogo(...toolkitCandidates: Array<string | null | undefined>): string | null {
  for (const candidate of toolkitCandidates) {
    if (!candidate?.trim()) continue;
    const slug = normalizeToolkitSlug(candidate);
    if (LOCAL_TOOLKIT_LOGOS[slug]) {
      return LOCAL_TOOLKIT_LOGOS[slug];
    }
  }

  return null;
}
